import { useNavigate } from 'react-router-dom';
import { LogoIcon } from 'assets';
import { Button } from 'view/components';
import * as S from './styled';

export const PublicHeader = () => {
  const navigate = useNavigate();

  return (
    <S.HeaderWrapper>
      <S.HeaderContent>
        <S.HeaderLeftBlock>
          <S.LogoWrapper
            onClick={() => {
              navigate('/jobs');
            }}
          >
            <LogoIcon />
          </S.LogoWrapper>
          <S.HeaderLink
            onClick={() => {
              navigate('/jobs');
            }}
          >
            Job Posts
          </S.HeaderLink>
          <S.HeaderLink
            onClick={() => {
              navigate('/companies');
            }}
          >
            Companies
          </S.HeaderLink>
        </S.HeaderLeftBlock>

        <S.HeaderRightBlock>
          <Button
            variant="outlined"
            text="Sign In"
            className="header-button"
            onClick={() => {
              navigate('/auth/login');
            }}
          />
          <Button
            variant="contained"
            text="Join"
            className="header-button"
            onClick={() => {
              navigate('/auth/registration');
            }}
          />
        </S.HeaderRightBlock>
      </S.HeaderContent>
    </S.HeaderWrapper>
  );
};
